jQuery(document).on('click', '.wlo-btn-wlo-pulse.wlo-pulse', function(){
    var headContent = document.getElementsByTagName('head')[0];
    var headContent = headContent.getElementsByTagName('script');  

    $( headContent ).each(function( index, val ) {
        var d_src = jQuery(val).attr('src');
        if(typeof d_src!='undefined'){
            var _data = d_src.split("&");

            if(_data[0].indexOf('https://dashboard.wheelio-app.com/api/wheelioapp/collectemail?') != -1){            
                localStorage.setItem('discount_code', JSON.stringify(_data) ); //store a key/value
            }
        }
    });
});